import styled, { css } from "styled-components"
import { Link } from "react-scroll"

import Breakpoints from "../shared/breakpoints"
import Typography from "../shared/typography.styles"

export const HeroOverlay = css`
  background-color: #7e2d16;
  mix-blend-mode: multiply;
`

export const HeroContent = styled.div`
  padding: 146px 0 280px 0;
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  color: var(--white);
  align-items: center;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    padding: 127px 0 157px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
    padding: 216px 0 148px 0;
  }
`

export const Title = styled.h1`
  ${Typography.mobileTextStyles.MobileHeadingTwoSemiBold}
  
  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingOneRegular}
    
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingTwoSemiBold}
  }
`

export const HeroLink = styled(Link)`
  cursor: pointer;
  ${Typography.desktopTextStyles.LinkText}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  background-color: var(--burnt-orange);
  color: var(--white);
  margin-top: 32px;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #fff;
`
